/** @format */
import { MvnoBlockListCollectionInterface } from '../../interfaces/collections/MvnoBlockListCollectionInterface';
import { MvnoBlockFunctionsCollection } from './BlockContainHelper';

export const BlockActions = {
    BLOCK_LIST_LOAD_GLOBAL_LIST: 'BLOCK_LIST_LOAD_GLOBAL_LIST',
    BLOCK_FUNCTION_LIST_LOAD: 'BLOCK_FUNCTION_LIST_LOAD',
    BLOCK_LIST_LOAD: 'BLOCK_LIST_LOAD',
};

export type BlockReducerType = {
    type: string;
    blockList?: MvnoBlockListCollectionInterface;
    blockListCollections?: MvnoBlockListCollectionInterface;
    blockFunctions?: MvnoBlockFunctionsCollection;
};

export const blockReducers = (state: any = {}, params: BlockReducerType): object => {
    switch (params.type) {
        case BlockActions.BLOCK_LIST_LOAD:
            return {
                type: params.type,
                blockListCollections: params.blockListCollections,
            };
        case BlockActions.BLOCK_LIST_LOAD_GLOBAL_LIST:
        case BlockActions.BLOCK_FUNCTION_LIST_LOAD:
        default:
            return {
                ...state,
                ...params,
            };
    }
};
